import axios from "axios";
import React, { useEffect, useState } from "react";
import DeleteConfirmation from "../Utility/DeleteConfirmation";
import { Pagination } from "../../helper/HelperTwo";
import { EyeIcon } from "lucide-react";
import { Tooltip } from "react-tooltip";
import LeadDiscusstion from "../AllLeadTask/LeadDiscusstion";
import TableHeader from "../Utility/TableHeader";

function LeadTaskList({
  setopenDialogBoxForLead,
  setLeadDetails,
  setSaveBtn,
  setLoading,
  allPaginationTaskDatas,
  allTaskDatas,
  setLeadTaskDetails,
  setLeadTaskFile,
  setEditId,
  setLeadType,
  fetchLeadTaskDatas,
  setIsEditing,
  setEditTaskIdCrypt,
  setSaveBtnOpen,
  id_crypt,
  showForm,
  taskBasedOnLead,
  setLeadIdCryptForTask,
  fetchLeadDatasForTask
}) {


  const userForView = JSON.parse(localStorage.getItem("user"));
  const taskPermissionForView = userForView?.task_role_based_access?.some(
    (access) => access.label_id == 6 && access.label_value != 0
  );

  const userForDelete = JSON.parse(localStorage.getItem("user"));
  const taskPermissionForDelete = userForDelete?.task_role_based_access?.some(
    (access) => access.label_id == 4 && access.label_value != 0
  );

  const userForDiscussion = JSON.parse(localStorage.getItem("user"));
  const taskPermissionForDiscussion =
    userForDiscussion?.task_role_based_access?.some(
      (access) => access.label_id == 5 && access.label_value != 0
    );

  const headers = [
    "S No",
    "Task Name",
    "Lead Name",
    "Start Date",
    "End Date",
    "Priority",
    "Task Status",
    "Task Members",
    "Action",
  ];
  const [currentPage, setCurrentPage] = useState(1);

  // const currentLoginIdForAdmin = parseInt(localStorage.getItem("role_id"), 10); //current login oda user_id 1 ah irundha ? ella datas um show panrom
  // const currentLoginIdForEmployee = JSON.parse(localStorage.getItem("user"))
  //   ?.employee?.id; // current login oda user la iruka employee oda id namba task la iruka task_member la iruka id oda match aachu apdina and employee oda tasks matum  list out panrom

  // const filteredTasks =
  //   currentLoginIdForAdmin === 1
  //     ? allPaginationTaskDatas?.data || []
  //     : (allPaginationTaskDatas?.data || []).filter((task) =>
  //         task.task_member.some(
  //           (member) =>
  //             parseInt(member.id, 10) === parseInt(currentLoginIdForEmployee)
  //         )
  //       );

  // const filteredTasks =
  //   currentLoginIdForAdmin === 1
  //     ? allTaskDatas || []
  //     : (allTaskDatas || []).filter((task) =>
  //         task.task_member.some(
  //           (member) =>
  //             parseInt(member.id, 10) === parseInt(currentLoginIdForEmployee)
  //         )
  //       );

  const [leadDiscusstion, setLeadDiscusstion] = useState(false);

  const handleViewForLead = async (e, id_crypt) => {
    e.preventDefault();
    setIsEditing(true);
    setopenDialogBoxForLead(true);
    setEditTaskIdCrypt(id_crypt);
    setSaveBtnOpen(false);
    setEditId(id_crypt);
    // setLeadIdCryptForTask(id_crypt);
  
    try {
      const response = await axios.get(`public/api/admin/tasks/edit/${id_crypt}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
  

      const task = response.data.task;
  
      // Determine task type
      setLeadType(task.task_type === "1" ? "general" : "lead");
  
      setLeadTaskDetails((prevDetails) => ({
        ...prevDetails,
        task_type: 2,
        lead_id: task.lead_name?.id, // Corrected: Use `task.lead_id` directly
        leads: task.lead_name?.id || "", // Corrected: `task.leads` holds the name
        task_name: task.task_name,
        task_status: task.task_status,
        task_members: task.task_member?.map((item) => item.id) || [],
        priority: task.priority,
        start_date: task.start_date,
        end_date: task.end_date,
        task_description: task.task_description,
      }));
  
      setLeadTaskFile(response?.data?.task?.task_files);
    } catch (error) {
      console.error("Error fetching task data:", error);
      // toast.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    if (showForm && id_crypt) {
      handleViewForLead(id_crypt);
    }
  }, [showForm, id_crypt]);



  const handlePageChange = (page) => {
    if (page !== "..." && !isNaN(page)) {
      const newPage = Number(page);
      setCurrentPage(newPage);
      fetchLeadTaskDatas(newPage);
    }
  };

  return (
    <>
      <div className="overflow-x-auto mt-8">
        <table className="min-w-full divide-y divide-gray-300">
          <TableHeader headers={headers} />

          <tbody className="divide-y divide-gray-200 bg-white">
            {/* {filteredTasks && filteredTasks?.length > 0 ? (
              filteredTasks?.map((lead, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 transition duration-300 ease-in-out"
                >
                  <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center">
                    {index + 1}
                  </td>
                  <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center">
                    {lead.task_name}
                  </td>
                  <td
                    className={`whitespace-nowrap text-md uppercase font-semibold sm:pl-4 text-center ${
                      lead.task_type === "1"
                        ? "text-blue-500"
                        : "text-green-500"
                    }`}
                  >
                    {lead.task_type == 1 ? "General" : "Lead"}
                  </td>
                  <td
                    className={`whitespace-nowrap text-md uppercase text-center sm:pl-4 ${
                      lead.leads ? "text-gray-900" : "text-cyan-600"
                    }`}
                  >
                    {lead.lead_name?.name || "Other"}
                  </td>
                  <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center">
                    {lead.priority_name?.name}
                  </td>
                  <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center">
                    <span
                      className={`border rounded px-2 py-1 ${
                        lead.task_status_name?.name === "Pending"
                          ? "border-blue-600 text-blue-600"
                          : lead.task_status_name?.name === "Completed"
                          ? "border-green-600 text-green-600"
                          : lead.task_status_name?.name === "Not Yet Started"
                          ? "border-red-500 text-red-500"
                          : lead.task_status_name?.name === "In Progress"
                          ? "border-purple-600 text-purple-600"
                          : "border-gray-400 text-gray-600"
                      }`}
                    >
                      {lead.task_status_name?.name}
                    </span>
                  </td>
                  <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center">
                    {lead.task_member?.map((item) => item.name).join(", ")}
                  </td>
                  <td className="flex space-x-2 items-center justify-center py-4 text-center text-sm text-gray-500 font-semibold">
                    {taskPermissionForDiscussion && (
                      <LeadDiscusstion
                        id_crypt={lead.id_crypt}
                        leadId={lead.id}
                        setLeadDiscusstion={setLeadDiscusstion}
                      />
                    )}

                    {taskPermissionForView && (
                      <span
                        className="my-anchor-view relative group cursor-pointer bg-blue-400 rounded-md p-1"
                        onClick={() => handleViewForLead(lead.id_crypt)}
                      >
                        <EyeIcon className="h-5 w-5 text-white" />
                        <Tooltip
                          anchorSelect=".my-anchor-view"
                          place="top"
                          className="text-xs p-0"
                          style={{ fontSize: "12px", padding: "0.3rem" }}
                        >
                          View
                        </Tooltip>
                      </span>
                    )}

                    {taskPermissionForDelete && (
                      <DeleteConfirmation
                        id_crypt={lead.id_crypt}
                        apiType="lead_task"
                        fetchClientData={fetchLeadTaskDatas}
                      />
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="text-center">
                  No Data Found
                </td>
              </tr>
            )} */}

            {/* {filteredTasks && filteredTasks?.length > 0 ? (
              filteredTasks?.map((lead, index) => ( */}
            {taskBasedOnLead?.tasks?.data?.map((task, index) => (
              <tr
                key={task.id}
                className="hover:bg-gray-50 transition duration-300 ease-in-out"
              >
                <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center">
                  {index + 1}
                </td>
                <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center">
                  {task.task_name}
                </td>
                <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center">
                  {task.lead_name?.name}
                </td>
                <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center">
                  {task.start_date}
                </td>
                <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center">
                  {task.end_date}
                </td>
                <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center">
                  {task.priority_name?.name}
                </td>
                <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center">
                  {task.task_status_name?.name}
                </td>
                <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center">
                  {task.task_member?.map((member) => member.name).join(", ")}
                </td>
                <td className="flex space-x-2 items-center justify-center py-4 text-center text-sm text-gray-500 font-semibold">
                  {taskPermissionForDiscussion && (
                    <LeadDiscusstion
                      id_crypt={task.id_crypt}
                      leadId={task.id}
                      setLeadDiscusstion={setLeadDiscusstion}
                    />
                  )}

                  {taskPermissionForView && (
                    <span
                      className="my-anchor-view relative group cursor-pointer bg-blue-400 rounded-md p-1"
                      onClick={(e) => handleViewForLead(e,task.id_crypt)}
                    >
                      <EyeIcon className="h-5 w-5 text-white" />
                      <Tooltip
                        anchorSelect=".my-anchor-view"
                        place="top"
                        className="text-xs p-0"
                      >
                        View
                      </Tooltip>
                    </span>
                  )}

                  {taskPermissionForDelete && (
                    <DeleteConfirmation
                      id_crypt={task.id_crypt}
                      apiType="lead_task"
                      fetchClientData={fetchLeadDatasForTask}
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>

          {/* </tbody> */}
        </table>
      </div>

      {/* <LeadDiscusstion setLeadDiscusstion={setLeadDiscusstion} leadDiscusstion={leadDiscusstion} idCryptForDiscussion={idCryptForDiscussion} /> */}

       {/* {taskBasedOnLead?.lead_task?.length > 0 ? (
        <Pagination
          links={allPaginationTaskDatas.links} // Keep original links for navigation
          currentPage={allPaginationTaskDatas.current_page}
          totalResults={filteredTasks.length} // Update total results based on filtered data
          from={filteredTasks.length > 0 ? 1 : 0} // Start from 1 if there are results
          to={filteredTasks.length} // Show the total count as the last item
          lastPage={Math.ceil(
            filteredTasks.length / (allPaginationTaskDatas.per_page || 10)
          )} // Calculate last page dynamically
          onPageChange={handlePageChange}
        />
      ) : (
        allPaginationTaskDatas && (
          <Pagination
            links={allPaginationTaskDatas.links}
            currentPage={allPaginationTaskDatas.current_page}
            totalResults={allPaginationTaskDatas.total}
            from={allPaginationTaskDatas.from}
            to={allPaginationTaskDatas.to}
            lastPage={allPaginationTaskDatas.last_page}
            onPageChange={handlePageChange}
          />
        )
      )}  */}

      {taskBasedOnLead?.tasks && (
                <Pagination
                  links={taskBasedOnLead?.tasks.links}
                  currentPage={taskBasedOnLead?.tasks.current_page}
                  totalResults={taskBasedOnLead?.tasks.total}
                  from={taskBasedOnLead?.tasks.from}
                  to={taskBasedOnLead?.tasks.to}
                  lastPage={taskBasedOnLead?.tasks.last_page}
                  onPageChange={handlePageChange}
                />
              )}
    </>
  );
}

export default LeadTaskList;
